import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import media from '../../styles/media.style';
import Placeholder from '../../components/Placeholder';
import SectionLabel from './SectionLabel';
import { MOBILE_PADDING, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

const BeliefSection = styled.section`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 50px ${MOBILE_PADDING}px 20px;

  ${media.tabletL`
    padding-bottom: 70px;
  `};
`;

const BeliefTitle = styled.div`
  font-size: 30px;
  font-style: oblique;
  line-height: 1.27;
  letter-spacing: 0.1px;
  text-align: center;

  ${media.tabletL`
    font-size: 50px;
    line-height: 1;
    letter-spacing: 0.3px;
  `};
`;

const CrossedOut = styled.span`
  text-decoration: line-through;
`;

const BeliefDetails = styled.div`
  color: #333;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: 0.1px;
  margin: 30px auto 0;
  max-width: 500px;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    color: black;
    font-size: 18px;
    line-height: 1.39;
    letter-spacing: 0.1px;
  `};
`;

const Belief = ({ label, title, description }) => (
  <BeliefSection id="our-belief-section">
    <SectionLabel>{label || <Placeholder h="20px" w="100px" />}</SectionLabel>
    <BeliefTitle>
      {title ? (
        <React.Fragment>
          {title.split(/\{.*\}/)[0]}
          <CrossedOut>{title.split(/[{}]/)[1]}</CrossedOut>
          {title.split(/\{.*\}/)[1]}
        </React.Fragment>
      ) : (
        <Placeholder h="50px" w="80%" />
      )}
    </BeliefTitle>
    <BeliefDetails>{description || <Placeholder h="50px" w="100%" />}</BeliefDetails>
  </BeliefSection>
);

Belief.defaultProps = {
  label: undefined,
  title: undefined,
  description: undefined,
};

Belief.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Belief;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/OurBeliefSection.js